import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { InputHandler as e } from "../../../input/InputHandler.js";
var t = .6;

var o = /*#__PURE__*/function (_e) {
  _inherits(o, _e);

  var _super = _createSuper(o);

  function o(e, t) {
    var _this;

    _classCallCheck(this, o);

    _this = _super.call(this, !0), _this.view = e, _this._canZoom = !0, _this.registerIncoming("mouse-wheel", t, function (e) {
      return _this._handleMouseWheel(e);
    });
    return _this;
  }

  _createClass(o, [{
    key: "_handleMouseWheel",
    value: function _handleMouseWheel(e) {
      var _this2 = this;

      if (!this.view.navigation.mouseWheelZoomEnabled) return;
      if (e.preventDefault(), e.stopPropagation(), !this._canZoom) return;

      var _o = this.view.mapViewNavigation,
          _e$data = e.data,
          n = _e$data.x,
          i = _e$data.y,
          s = _e$data.deltaY,
          a = 1 / Math.pow(t, 1 / 60 * s),
          h = _o.zoom(a, [n, i]);

      h && (this._canZoom = !1, h.catch(function () {}).then(function () {
        _this2._canZoom = !0, _o.end();
      }));
    }
  }]);

  return o;
}(e);

export { o as MouseWheelZoom };